/*
 * Carousels and the product countdown element.
 *
 * Extracted from layout/theme.liquid (COSNETIC V2, 2026-09-20) so that it and Swiper can
 * both be deferred and cached by the CDN rather than re-sent inline on every page.
 *
 * Loaded with `defer`, so Swiper is already defined and the DOM is already parsed when
 * this runs -- no DOMContentLoaded wrapper needed.
 */
(function () {
  if (typeof Swiper === 'undefined') return;

  var script = document.currentScript || document.querySelector('script[data-selling-fast-speed]');
  var sellingFastSpeed = parseInt((script && script.dataset.sellingFastSpeed) || '3000', 10);

    // Badge carousel - vanilla init (jQuery removed 2026-09-12).
    // Swiper's <script> sits above this one, so it is already defined.
    (function () {
      function initBadgeSwiper() {
        if (typeof Swiper === 'undefined') return;
        document.querySelectorAll('.swiper-container-badges').forEach(function (el) {
          if (el.dataset.badgeSwiperReady) return;
          el.dataset.badgeSwiperReady = '1';
          new Swiper(el, { slidesPerView: 'auto' });
        });
      }
      if (document.readyState !== 'loading') initBadgeSwiper();
      else document.addEventListener('DOMContentLoaded', initBadgeSwiper);
    })();

   // Timer
  class ProductCounter extends HTMLElement {
    constructor() {
      super();
      this.element = this.querySelector(".countdown-timer_main");
      this.init()
    }
    async init () {
      const countdownDate = new Date(this.element.getAttribute("data-countdown-date")).getTime();
      const updateCountdown = setInterval(() => {
              const now = new Date().getTime();
              const distance = countdownDate - now;
              if (distance < 0) {
                  clearInterval(updateCountdown);
                  this.element.querySelector(".countdown-timer").innerHTML = "<span>The countdown has ended!</span>";
                  return;
              }
              // Calculate time units
              const days = Math.floor(distance / (1000 * 60 * 60 * 24));
              const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              const seconds = Math.floor((distance % (1000 * 60)) / 1000);
              // Update the element's timer
              this.element.querySelector(".days").innerText = days;
              this.element.querySelector(".hours").innerText = hours;
              this.element.querySelector(".minutes").innerText = minutes;
              this.element.querySelector(".seconds").innerText = seconds;
          }, 1000);
    }
  }
  customElements.define('product-counter', ProductCounter);

   // product-card_swiper
    setTimeout(() => {
      let product_cardswiper = new Swiper('.product-card_swiper', {
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        lazy: true,
      });
    }, 2000);

  // Stock is selling fast
  var sellingQuicklySwiper = new Swiper('.swiper-selling_quickly', {
    loop: true,
    autoplay: {
        delay: 1000,
    },
    speed: sellingFastSpeed,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
  })

  // announcement-bar-new
  var announcementSwiper = new Swiper('.announcement-bar-new_slide', {
    loop: true,
    autoplay: {
        delay: 1000,
    },
    speed: 3000,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
  })

})();
